


import {
  defineComponent,
  reactive,
} from '@vue/composition-api';
import useSettouPatrolContext from '@/components/Sp/Johaisetsu/SettouPatrol/composables/useSettouPatrolContext';

interface State {
  showConfirmStartWorkingModal: boolean;
  showConfirmStopWorkingModal: boolean;
}

export default defineComponent({
  props: {
    selectedJohaisetsuType: {
      type: String,
      required: true,
    },
    isRequesting: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const state = reactive<State>({
      showConfirmStartWorkingModal: false,
      showConfirmStopWorkingModal: false,
    });
    const {
      johaisetsuTypeNameDisp,
      sagyouActionLabel,
      isShowJohaisetsuTypeSelect,
      restartWorkingLabel,
      stopWorkingLabel,
    } = useSettouPatrolContext({ selectedJohaisetsuType: props.selectedJohaisetsuType });
    const editWorkSituation = (): void => {
      emit('editWorkSituationOnCommon');
    };
    const tryShowConfirmStartWorkingModal = (): void => {
      state.showConfirmStartWorkingModal = true;
    };
    const startWorking = (): void => {
      state.showConfirmStartWorkingModal = false;
      emit('startWorkingOnCommon');
    };
    const showConfirmStopWorkingModal = (): void => {
      state.showConfirmStopWorkingModal = true;
    };
    const stopWorking = (): void => {
      state.showConfirmStopWorkingModal = false;
      emit('stopWorkingOnCommon');
    };

    return {
      state,
      johaisetsuTypeNameDisp,
      sagyouActionLabel,
      isShowJohaisetsuTypeSelect,
      restartWorkingLabel,
      stopWorkingLabel,
      editWorkSituation,
      tryShowConfirmStartWorkingModal,
      startWorking,
      showConfirmStopWorkingModal,
      stopWorking,
    };
  },
});
